import { Input, Flex, Image, Heading, Text } from '@chakra-ui/react';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import "../../App.css"
import loadingGif from "../../assets/loadingIcon.gif";
import useForceUpdate from "use-force-update";
import { BsPerson } from "react-icons/bs";
import { IoChevronBackCircleOutline, IoPeopleOutline } from "react-icons/io5";
import { RiFilePaper2Line } from "react-icons/ri";
import { useColorMode } from "../../components/ui/color-mode";
import { Button } from "../../components/ui/button";

interface IWorkResult {
    AddressLine: string,
    AllocationId: string,
    AllocationStatus: number,
    AppointmentDate: string,
    AppointmentId: string,
    DisciplineId: string,
    EndTime: string,
    EngineerId: string,
    EngineerName: string,
    Expected: string,
    IsAccepted: boolean,
    IsAccountWork: boolean,
    IsOnOrder: boolean,
    IsOrderLate: boolean,
    JobNumber: string,
    PostCode: string,
    StartTime: string,
    value: number,
    cb: Function,
    ringmaster: string,
    disciplineName: string,
    disciplineAccent: string,
    isActive: boolean,
    RouteIndex: number,

}

export const StaffPage = () => {
    const [ignore, setIgnore] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const [engineerList, setEngineerList] = useState<any[]>([]);
    const { colorMode, toggleColorMode } = useColorMode();
    let navigate = useNavigate();

    useEffect(() => {
        window.addEventListener('error', e => {
            if (e.message === 'ResizeObserver loop limit exceeded') {
                const resizeObserverErrDiv = document.getElementById(
                    'webpack-dev-server-client-overlay-div'
                );
                const resizeObserverErr = document.getElementById(
                    'webpack-dev-server-client-overlay'
                );
                if (resizeObserverErr) {
                    resizeObserverErr.setAttribute('style', 'display: none');
                }
                if (resizeObserverErrDiv) {
                    resizeObserverErrDiv.setAttribute('style', 'display: none');
                }
            }
        });
    }, []);

    const handleGoBack = () => {
        navigate("/dashboard")
    }
    const handleUserClick = () => {
        navigate("/staff/users");
    }
    const handleGroupClick = () => {
        navigate("/staff/groups");
    }
    const handlePermissionClick = () => {
        navigate("/staff/permissions")
    }
    const handleKeyDown = (event: any) => {

    }
    
    return (
        // <ScaleFade initialScale={1} in={isPageOpen}>
        <>
            {loading ?
                <>
                    <Heading marginTop={"20px"} as={"i"} color={colorMode === 'light' ? "AbleBlue" : "AbleYellow"} fontWeight={"lighter"} >Staff Management</Heading>

                    <Flex direction={'row'} h='calc(100vh - 150px)' justifyContent={"center"}> {/* Bit of a bodge for now - have to manually set height based on hardcoded header height */}
                        <Flex direction={"column"} marginRight={"10px"}>
                            <Button colorScheme="blue" bgColor={"backgroundDarkGrey"} marginTop={"10px"} _hover={{ bg: colorMode === 'light' ? "AbleBlue" : "AbleYellow", color: "backgroundDarkGrey" }} color={colorMode === "light" ? "AbleBlue" : "AbleYellow"}
                                onClick={handleGoBack} size={"lg"} height={"150px"} width={"150px"} _active={{ bg: "AbleYellow" }}><IoChevronBackCircleOutline size={"md"} /></Button>
                            <Text as={"b"}>Go Back</Text>
                        </Flex>
                        <Flex direction={"column"} marginRight={"10px"}>
                            <Button colorScheme="blue" bgColor={"backgroundDarkGrey"} marginTop={"10px"} _hover={{ bg: colorMode === 'light' ? "AbleBlue" : "AbleYellow", color: "backgroundDarkGrey" }} color={colorMode === "light" ? "AbleBlue" : "AbleYellow"}
                                onClick={handleUserClick} size={"lg"} height={"150px"} width={"150px"} _active={{ bg: "AbleYellow" }}><BsPerson size={"md"} /></Button>
                            <Text as={"b"}>Users</Text>
                        </Flex>
                        <Flex direction={"column"} marginRight={"10px"}>
                            <Button colorScheme="blue" bgColor={"backgroundDarkGrey"} marginTop={"10px"} _hover={{ bg: colorMode === 'light' ? "AbleBlue" : "AbleYellow", color: "backgroundDarkGrey" }} color={colorMode === "light" ? "AbleBlue" : "AbleYellow"}
                                onClick={handleGroupClick} size={"lg"} height={"150px"} width={"150px"} _active={{ bg: "AbleYellow" }}><IoPeopleOutline size={"md"} /></Button>
                            <Text as={"b"}>Groups</Text>
                        </Flex>
                        <Flex direction={"column"}>
                            <Button colorScheme="blue" bgColor={"backgroundDarkGrey"} marginTop={"10px"} _hover={{ bg: colorMode === 'light' ? "AbleBlue" : "AbleYellow", color: "backgroundDarkGrey" }} color={colorMode === "light" ? "AbleBlue" : "AbleYellow"}
                                onClick={handlePermissionClick} size={"lg"} height={"150px"} width={"150px"} _active={{ bg: "AbleYellow" }}><RiFilePaper2Line size={"md"} /></Button>
                            <Text as={"b"}>Permissions</Text>
                        </Flex>
                        {/* <ScaleFade initialScale={0.1} in={defaultView}>
                        </ScaleFade> */}

                    </Flex>
                </>
                :
                <Flex direction={"row"} justifyContent={"center"} width={"100%"} marginTop={"11%"} bgColor={"white"}>
                    <Image srcSet={loadingGif} alt="loading..." boxSize={'400px'} objectFit={"cover"} />
                </Flex>

            }
        </>
    )
}
